// extracted by mini-css-extract-plugin
export default {"LeagueTable":"style_LeagueTable__sKQ5l","fadeInRow":"style_fadeInRow__nD3i9"};